import { render, staticRenderFns } from "./mod20.vue?vue&type=template&id=0ff73b4a&scoped=true&"
import script from "./mod20.vue?vue&type=script&lang=js&"
export * from "./mod20.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff73b4a",
  null
  
)

export default component.exports